module.exports = __webpack_public_path__ + "img/serve4.f7d2846b.png";